import React, { useContext, useEffect, useRef, useState } from 'react'
import { DeviceDetailsPopup } from '../../Components/DeviceDetailsPopup';
import { ApiCmnHeadersPostCall, ApiGetCall, ApiGetHeaders } from '../../JS/Connector';
import { CamelCaseWithSpaces, formatDateToUsaMMDDYYYY, formatDecimal, getTypeWatchDelay, transformNameOfCol, typewatch } from '../../JS/Common';
import { useLocation, useNavigate } from 'react-router-dom';
import TicketStatuspopup from '../../Components/TicketStatuspopup';
import TicketDetailsPopup from '../../Components/TicketDetailsPopup';
import TicketStatusDropdown from '../../Components/TicketStatusDropdown';
import Pagination from 'react-js-pagination';
import CustomizationPopup from '../../Components/CustomizationPopup';
import UserDetailsPopup from '../../Components/UserDetailsPopup';
import jinja from 'jinja-js';
import AdminCreateBatch from './AdminCreateBatch';
import { Schoolsearchbar } from '../../Components/Schoolsearchbar';
import AlertsComp from '../../Components/AlertsComp';
import PageHead from '../../Components/PageHead';
import Tab from '../../Components/Tab';
import SchoolProfileInfo from '../SchoolProfile/SchoolProfileInfo';
import Popup from '../../Components/Popup';
import { UserContext } from '../../App';
import CustomSVG from '../../Components/CustomSVG';
import { log } from '../../JS/Logger';
import { useSelector } from 'react-redux';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';
import { BaseUrl } from '../../JS/Common';
import DOMPurify from 'dompurify';
import { useGetCustomFieldsName, useStickyAction } from '../../Hooks';
import CustomFieldInfoIcon from '../../Components/CustomFieldInfoIcon';

export function SchoolTickets() {
    const { tickets_grid_name, school, show_device_complete_club, organization, print_ticket_logo, short_form_dcc,
        print_ticket_fevicon, print_ticket_link, print_ticket_coverage, adminCallNode, dcc_module_text
    } = useConfig();
    const { UserData } = useContext(UserContext);
    const navigate = useNavigate();
    const StateData = useSelector((state) => state.authData);
    const storedSearchValue = StateData?.AdminSchoolId;
    const pathname = window.location.pathname;
    const pathArray = pathname.split('/');
    const batchid = pathArray[2];
    const location = useLocation();
    const TicketIdFromCreateTicket = location.state && location.state.ticketid;

    const [TicketsTabs, setTicketsTabs] = useState({
        atVendorTicketTab: '',
        sentOutForRepair: 'active',
        openTicketTab: "",
        repairFinishedTicketTab: '',
        repairBilledTicketTab: '',

        SearchForOpen: '',
        SearchForRepairFinished: '',
        searchForSentOutForRepair: '',
        SearchForAtVendor: '',
        SearchForRepairBilled: '',
        SearchForClosed: '',

        numberOfTicketCount: 0,
        numberofSubtotal: 0,
        sortbykey: null,
        sortbyflag: "asc"
    });
    const [schoolhaveclub, setSchoolhaveclub] = useState(0);
    const [TicketParams, setTicketParams] = useState({
        inventoryId: '',
        ticketId: '',
        flag: 1,
    });
    const [IsModal, setIsModal] = useState({
        isshowpopup: false,
        isTicketDetailspopup: false,
        CreateBatchmodal: false,
        CreateBatchbuttonVisible: false,
        isTicketStatuspopup: false,
        DeviceNameForAmountMOdal: '',
        subtotal: 0,
        TicketStatusId: ''
    });
    const [StudentidForSatuschange, setStudentidForSatuschange] = useState('')
    const [selectedItems, setSelectedItems] = useState([]);
    const [tabflag, settabflag] = useState(1);
    const [noteVisibility, setNoteVisibility] = useState({});
    const [schoolId, setSchoolId] = useState('');
    const [selectedIds, setSelectedIds] = useState([]);
    const [Batches, setBatches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedbatchid, setselectedbatchid] = useState(0);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [SelectBuildingID, setSelectBuildingID] = useState(null)
    const [BuildingNames, setBuildingNames] = useState([])
    const [CustomFieldNames, setCustomFieldNames] = useState([]);
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [UserModal, setUserModal] = useState(false)
    const [Userid, setUserid] = useState('');
    const [alert, setAlert] = useState('')
    const [schoolProfilePopup, setSchoolProfilePopup] = useState(false)

    const [GridDataForAtVendor, setGridDataForAtVendor] = useState([]);
    const [GridDataForSentOutTicket, setGridDataForSentOutTicket] = useState([]);
    const [GridDataForOpen, setGridDataForOpen] = useState([]);
    const [GridDataForRepairFinished, setGridDataForRepairFinished] = useState([]);
    const [GridDataForRepairBilled, setGridDataForRepairBilled] = useState([]);
    const [GridDataForClosed, setGridDataForClosed] = useState([]);

    const [selectedIdsAtVendor, setSelectedIdsAtVendor] = useState([]);
    const [selectedIdsSentOut, setSelectedIdsSentOut] = useState([]);
    const [selectedIdsOpen, setSelectedIdsOpen] = useState([]);
    const [selectedIdsRepairFinished, setSelectedIdsRepairFinished] = useState([]);
    const [selectedIdsRepairBilled, setSelectedIdsRepairBilled] = useState([]);
    const [selectedIdsClosed, setSelectedIdsClosed] = useState([]);

    const [selectedIdsAtVendor1, setSelectedIdsAtVendor1] = useState([]);
    const [selectedIdsSentOut1, setSelectedIdsSentOut1] = useState([]);
    const [selectedIdsOpen1, setSelectedIdsOpen1] = useState([]);
    const [selectedIdsRepairFinished1, setSelectedIdsRepairFinished1] = useState([]);
    const [selectedIdsRepairBilled1, setSelectedIdsRepairBilled1] = useState([]);
    const [selectedIdsClosed1, setSelectedIdsClosed1] = useState([]);

    const showPaginationAtVendor = GridDataForAtVendor.length > 0;
    const showPaginationSendOut = GridDataForSentOutTicket.length > 0;
    const showPaginationOpen = GridDataForOpen.length > 0;
    const showPaginationRepairFinished = GridDataForRepairFinished.length > 0;
    const showPaginationRepairBilled = GridDataForRepairBilled.length > 0;
    const showPaginationClosed = GridDataForClosed.length > 0;

    const [sortingNumForAtvendor, setSortingNumForAtvendor] = useState(0)
    const [sortingNumForSentOut, setSortingNumForSentOut] = useState(0)
    const [sortingNumForOpen, setSortingForOpen] = useState(0)
    const [sortingNumForRepairFinished, setSortingNumForRepairFinished] = useState(0)
    const [sortingNumForRepairBilled, setSortingNumForRepairBilled] = useState(0)
    const [sortingNumForClosed, setSortingNumForClosed] = useState(0)
    const [totalTicketCount, setTotalTicketCount] = useState(0);
    const [partsTotal, setPartsTotal] = useState(0);
    const [selectAllFlag, setSelectAllFlag] = useState(0);
    const effectiveRole = UserData.copyrole || UserData.role || null;
    const excludeVar = hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_VAR);
    const onlyVar = hasRoleAccess(effectiveRole, RoleEnum.ONLY_VAR);

    const skipGridEffectRef = useRef(false);
    const resetGridEffectSkip = () => {
        skipGridEffectRef.current = false;
    };

    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);
    const { AllCustomFieldNamesColor } = useGetCustomFieldsName();

    useEffect(() => {
        const isAlertShownInHistory = window.history.state && window.history.state.alertShown;
        if (TicketIdFromCreateTicket != null && !isAlertShownInHistory) {
            setAlert(<AlertsComp show={true} variant="success" msg={`Ticket (${TicketIdFromCreateTicket}) Created Successfully`} />);
            window.history.pushState({ alertShown: true }, '');
            setTimeout(function () {
                setAlert(<AlertsComp show={false} />);
            }, 5000);
        }
    }, [TicketIdFromCreateTicket]);
    useEffect(() => {
        setselectedbatchid(batchid)
    }, [])
    useEffect(() => {
        AllCustomFieldNamesColor(setCustomFieldNames, true);
    }, [])
    useEffect(() => {
        ApiGetHeaders(26, setColumnNames, 1, StateData?.AdminSchoolId) //atvendor
    }, [storedSearchValue, CustomizationModal]);
    useEffect(() => {
        if (skipGridEffectRef.current) {
            skipGridEffectRef.current = false;
            return;
        }
        setSchoolId(storedSearchValue);
        if (storedSearchValue != undefined) {
            AllReturnLocation();
            AllBatches();
            if (TicketsTabs.sentOutForRepair == "active") {
                if (tabflag == 1) {
                    GetGridData(TicketsTabs.SearchForAtVendor || null, 1, batchid, sortingNumForAtvendor || null, false)//atvendor
                } else if (tabflag == 2) {
                    GetGridData(TicketsTabs.searchForSentOutForRepair || null, 2, batchid || selectedbatchid, sortingNumForSentOut || null, false)//sendoutforrepair
                } else if (tabflag == 3) {
                    GetGridData(TicketsTabs.SearchForOpen || null, 3, batchid, sortingNumForOpen || null, false)//open
                }
            } else if (TicketsTabs.repairFinishedTicketTab == 'active') {
                if (tabflag == 4) {
                    GetGridData(TicketsTabs.SearchForRepairFinished ? TicketsTabs.SearchForRepairFinished : null, 4, batchid, sortingNumForRepairFinished || null, false)//repaired finished
                } else if (tabflag == 5) {
                    GetGridData(TicketsTabs.SearchForRepairBilled ? TicketsTabs.SearchForRepairBilled : null, 5, batchid, sortingNumForRepairBilled || null, false)//repaired billed
                } else if (tabflag == 6) {
                    GetGridData(TicketsTabs.SearchForClosed ? TicketsTabs.SearchForClosed : null, 6, batchid, sortingNumForClosed || null, false)//closed
                }
            }
        }
    }, [storedSearchValue, currentPage, LimitForPagination, sortingNumForSentOut, sortingNumForOpen, sortingNumForRepairFinished, sortingNumForRepairBilled, sortingNumForAtvendor, SelectBuildingID]);

    useEffect(() => {
        const selectedArray = [
            ...selectedIdsOpen1.map((item) => ({ id: item?.id, allpartstotal: item?.allpartstotal || 0, subTotal: item?.sub_total || 0, studentID: item?.StudentID, batchflag: item?.batchflag, repairstatus: item.repairstatus })),
            ...selectedIdsRepairFinished1.map((item) => ({ id: item?.id, allpartstotal: item?.allpartstotal || 0, subTotal: item?.sub_total || 0, studentID: item?.StudentID, batchflag: item?.batchflag, repairstatus: item.repairstatus })),
            ...selectedIdsRepairBilled1.map((item) => ({ id: item?.id, allpartstotal: item?.allpartstotal || 0, subTotal: item?.sub_total || 0, studentID: item?.StudentID, batchflag: item?.batchflag, repairstatus: item.repairstatus })),
            ...selectedIdsSentOut1.map((item) => ({ id: item?.id, allpartstotal: item?.allpartstotal || 0, subTotal: item?.sub_total || 0, studentID: item?.StudentID, batchflag: item?.batchflag, repairstatus: item.repairstatus })),
            ...selectedIdsAtVendor1.map((item) => ({ id: item?.id, allpartstotal: item?.allpartstotal || 0, subTotal: item?.sub_total || 0, studentID: item?.StudentID, batchflag: item?.batchflag, repairstatus: item.repairstatus })),
            ...selectedIdsClosed1.map((item) => ({ id: item?.id, allpartstotal: item?.allpartstotal || 0, subTotal: item?.sub_total || 0, studentID: item?.StudentID, batchflag: item?.batchflag, repairstatus: item.repairstatus })),
        ];
        const idAndSubtotalArray = selectedArray.map(({ id, allpartstotal, subTotal, studentID, batchflag, repairstatus }) => ({ uuid: id, allpartstotal: allpartstotal, subTotal: subTotal, studentId: studentID == undefined ? null : studentID, batchflag: batchflag, repairstatus: repairstatus }));
        setSelectedItems(idAndSubtotalArray);
        if (selectedIdsOpen1.length === 0 && selectedIdsRepairFinished1.length === 0 && selectedIdsRepairBilled1.length === 0 && selectedIdsSentOut1.length === 0 && selectedIdsAtVendor1.length === 0 && selectedIdsClosed1.length === 0) {
            setIsModal({ ...IsModal, CreateBatchbuttonVisible: false });
        }
        const selectedOnlyID = selectedArray.map(({ id, studentID, batchflag, repairstatus }) => ({ ID: id, StudentID: studentID == undefined ? null : studentID, batchflag: batchflag, repairstatus: repairstatus }));
        setSelectedIds(selectedOnlyID)
        const ticketcount = selectedArray
            ?.filter(item => item.batchflag == 0)
            ?.map(({ id, allpartstotal, subTotal, studentID }) => ({
                ID: id,
                SubTotal: parseFloat(subTotal),
                allpartstotal: parseFloat(allpartstotal),
                StudentID: studentID === undefined ? null : studentID
            }));

        const idCount = ticketcount.length;
        const subtotalSum = ticketcount.reduce((acc, { allpartstotal }) => acc + allpartstotal, 0);
        setTicketsTabs({ ...TicketsTabs, numberOfTicketCount: idCount, numberofSubtotal: formatDecimal(subtotalSum) })
    }, [selectedIdsOpen, selectedIdsRepairFinished, selectedIdsRepairBilled, selectedIdsSentOut, selectedIdsAtVendor, selectedIdsOpen1, selectedIdsRepairFinished1, selectedIdsRepairBilled1, selectedIdsSentOut1, selectedIdsAtVendor1, selectedIdsClosed, selectedIdsClosed1])

    async function AllBatches() {
        await ApiGetCall(`/schools/batches/names?schoolId=${storedSearchValue}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs?.status == 'error') return;
                setBatches(responseRs?.msg?.length ? responseRs.msg : [])
            }
        });
    }
    async function AllReturnLocation() {
        await ApiGetCall(`/tickets/return-locations/all?schoolId=${storedSearchValue}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs?.status == 'error') return;
                const sortedList = responseRs?.msg?.length > 0 ? responseRs.msg.sort((a, b) => a?.return_location?.name?.localeCompare(b?.return_location?.name)) : [];
                setBuildingNames(sortedList);
            }
        });
    }
    function GetGridData(SearchString, flag, batchid, sortbykey, toogleSort, isGlobalSearch = false) {
        if (batchid == "0" || batchid == undefined) {
            batchid = null;
        }
        settabflag(flag);
        if (!SearchString) {
            SearchString = null;
        } else {
            SearchString = SearchString?.trim() || null;
        }
        if (sortbykey && toogleSort) TicketsTabs.sortbyflag = TicketsTabs.sortbyflag == "asc" ? "desc" : "asc";
        var sortbykeyy;
        if (flag == 1) {
            if (sortingNumForAtvendor != 0) {
                sortbykeyy = sortingNumForAtvendor
            } else {
                sortbykeyy = sortbykey
            }

        } else if (flag == 2) {
            if (sortingNumForSentOut != 0) {
                sortbykeyy = sortingNumForSentOut
            } else {
                sortbykeyy = sortbykey
            }

        } else if (flag == 3) {
            if (sortingNumForOpen != 0) {
                sortbykeyy = sortingNumForOpen
            } else {
                sortbykeyy = sortbykey
            };

        } else if (flag == 4) {
            if (sortingNumForRepairFinished != 0) {
                sortbykeyy = sortingNumForRepairFinished
            } else {
                sortbykeyy = sortbykey
            }
        } else if (flag == 5) {
            if (sortingNumForRepairBilled != 0) {
                sortbykeyy = sortingNumForRepairBilled
            } else {
                sortbykeyy = sortbykey
            }
        } else if (flag == 6) {
            if (sortingNumForClosed != 0) {
                sortbykeyy = sortingNumForClosed
            } else {
                sortbykeyy = sortbykey
            }
        }
        const ParamsBuildingId = SelectBuildingID && SelectBuildingID?.trim() != "" ? SelectBuildingID : null;
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`${adminCallNode}/panels/all-tickets?sortBy=${encodeURIComponent(sortbykeyy)}&sortByOrder=${encodeURIComponent(TicketsTabs.sortbyflag)}&schoolId=${encodeURIComponent(storedSearchValue)}&search=${encodeURIComponent(SearchString)}&page=${encodeURIComponent(isGlobalSearch ? 1 : currentPage)}&limit=${encodeURIComponent(LimitForPagination)}&status=${encodeURIComponent(flag)}&batchId=${encodeURIComponent(batchid)}&buildingId=${encodeURIComponent(isGlobalSearch ? null : ParamsBuildingId)}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    setSchoolhaveclub(responseRs.schoolhaveclub)
                    setpageRangeCount(responseRs.total)
                    setGridDataForAtVendor([])
                    setGridDataForSentOutTicket([])
                    setGridDataForOpen([])
                    setGridDataForRepairFinished([])
                    setGridDataForRepairBilled([])
                    setGridDataForClosed([])
                    setPartsTotal(responseRs?.tabtotalpartsflag)
                    setTotalTicketCount(responseRs?.tabtotalticket)
                    if (responseRs.data.length != 0) {
                        const GridData = responseRs?.data
                        if (flag == 1) {
                            setGridDataForAtVendor(GridData)
                            if (selectAllFlag == 1) {
                                setSelectedIdsAtVendor(GridData?.map(item => item.id))
                                setSelectedIdsAtVendor1(GridData?.map(item => ({ id: item.id, allpartstotal: item.sub_total, sub_total: item.onlyadminpartsprice_total, studentID: item?.student_i_d || null, batchflag: item.batch_flag, repairstatus: item.repair_status })))
                            }
                        } else if (flag == 2) {
                            setGridDataForSentOutTicket(GridData)
                            if (selectAllFlag == 1) {
                                setSelectedIdsSentOut(GridData?.map(item => item.id))
                                setSelectedIdsSentOut1(GridData?.map(item => ({ id: item.id, allpartstotal: item.sub_total, sub_total: item.onlyadminpartsprice_total, studentID: item?.student_i_d || null, batchflag: item.batch_flag, repairstatus: item.repair_status })))
                            }
                        } else if (flag == 3) {
                            setGridDataForOpen(GridData);
                            if (selectAllFlag == 1) {
                                setSelectedIdsOpen(GridData?.map(item => item.id))
                                setSelectedIdsOpen1(GridData?.map(item => ({
                                    id: item.id, allpartstotal: item.sub_total, sub_total: item.onlyadminpartsprice_total, studentID: item?.student_i_d || null, batchflag: item.batch_flag,
                                    repairstatus: item.repair_status,
                                })))
                            }
                        } else if (flag == 4) {
                            setGridDataForRepairFinished(GridData);
                            if (selectAllFlag == 1) {
                                setSelectedIdsRepairFinished(GridData?.map(item => item.id))
                                setSelectedIdsRepairFinished1(GridData?.map(item => ({
                                    id: item.id, allpartstotal: item.sub_total, sub_total: item.onlyadminpartsprice_total, studentID: item?.student_i_d || null,
                                    batchflag: item.batch_flag, repairstatus: item.repair_status
                                })))
                            }
                        } else if (flag == 5) {
                            setGridDataForRepairBilled(GridData);
                            if (selectAllFlag == 1) {
                                setSelectedIdsRepairBilled(GridData?.map(item => item.id))
                                setSelectedIdsRepairBilled1(GridData?.map(item => ({ id: item.id, allpartstotal: item.sub_total, sub_total: item.onlyadminpartsprice_total, studentID: item?.student_i_d || null, batchflag: item.batch_flag, repairstatus: item.repair_status })))
                            }
                        } else if (flag == 6) {
                            setGridDataForClosed(GridData);
                            if (selectAllFlag == 1) {
                                setSelectedIdsClosed(GridData?.map(item => item.id))
                                setSelectedIdsClosed1(GridData?.map(item => ({ id: item.id, allpartstotal: item.sub_total, sub_total: item.onlyadminpartsprice_total, studentID: item?.student_i_d || null, batchflag: item.batch_flag, repairstatus: item.repair_status })))
                            }
                        }
                    }
                }
            });
        }, getTypeWatchDelay(SearchString, 500));
    }
    function handleArrowClick(ticketId) {
        setNoteVisibility((prevState) => ({ ...prevState, [ticketId]: !prevState[ticketId], }));
    };
    function CreateBatchPopupShow() {
        setIsModal({ ...IsModal, CreateBatchmodal: true })
    }
    function handleSetSchoolId(id) {
        resetGridEffectSkip();
        setSchoolId(id);
        const clearGridInput = document.getElementById("grid-search-box");
        if (clearGridInput) {
            clearGridInput.value = "";
        }
        setTicketsTabs({ ...TicketsTabs, SearchForAtVendor: "", searchForSentOutForRepair: "", SearchForOpen: "", SearchForRepairFinished: "", SearchForRepairBilled: "", SearchForClosed: "" });
    };
    const hasZeroFlag = (ticketsArray, flagKey = 'batchflag') => {
        return ticketsArray.some(item => item[flagKey] == 0);
    };
    function handleHeaderCheckboxChange(e, ticketFlag) {
        const isChecked = e.target.checked;

        const getSelectableIds = (data) => data.map(item => item.id);
        const getSelectableIds1 = (data) => data
            .map(item => ({
                id: item.id, allpartstotal: item.sub_total, sub_total: item.onlyadminpartsprice_total,
                studentID: item?.student_i_d || null, batchflag: item.batch_flag, repairstatus: item.repair_status,
            }));

        // Helper: merge current page into existing selections (no duplicates)
        const mergeIds = (prev, currentPageIds) => [
            ...prev.filter(id => !currentPageIds.includes(id)),
            ...currentPageIds
        ];
        const mergeIds1 = (prev, currentPageItems) => [
            ...prev.filter(p => !currentPageItems.some(i => i.id === p.id)),
            ...currentPageItems
        ];
        // Helper: remove current page from existing selections
        const removeIds = (prev, currentPageIds) => prev.filter(id => !currentPageIds.includes(id));
        const removeIds1 = (prev, currentPageItems) => prev.filter(p => !currentPageItems.some(i => i.id === p.id));

        const apply = (currentPageData, setIds, setIds1) => {
            const ids = getSelectableIds(currentPageData);
            const ids1 = getSelectableIds1(currentPageData);

            if (isChecked) {
                setIds(prev => mergeIds(prev, ids));
                setIds1(prev => {
                    const nextItems = mergeIds1(prev, ids1);
                    setIsModal(m => ({ ...m, CreateBatchbuttonVisible: hasZeroFlag(nextItems) }));
                    return nextItems;
                });
            } else {
                setIds(prev => removeIds(prev, ids));
                setIds1(prev => {
                    const nextItems = removeIds1(prev, ids1);
                    setIsModal(m => ({ ...m, CreateBatchbuttonVisible: hasZeroFlag(nextItems) }));
                    return nextItems;
                });
            }
        };

        if (ticketFlag == "open") {
            apply(GridDataForOpen, setSelectedIdsOpen, setSelectedIdsOpen1);
        } else if (ticketFlag == 'repairfinished') {
            apply(GridDataForRepairFinished, setSelectedIdsRepairFinished, setSelectedIdsRepairFinished1);
        } else if (ticketFlag == 'sentout') {
            apply(GridDataForSentOutTicket, setSelectedIdsSentOut, setSelectedIdsSentOut1);
        } else if (ticketFlag == 'atvendor') {
            apply(GridDataForAtVendor, setSelectedIdsAtVendor, setSelectedIdsAtVendor1);
        } else if (ticketFlag == 'repairbilled') {
            apply(GridDataForRepairBilled, setSelectedIdsRepairBilled, setSelectedIdsRepairBilled1);
        } else if (ticketFlag == 'closed') {
            apply(GridDataForClosed, setSelectedIdsClosed, setSelectedIdsClosed1);
        }
    }
    function handleCheckboxChange(e, ticketFlag, ticketID, allpartstotal, sub_total, studentID, batchflag, repairstatus) {
        const isChecked = e.target.checked;

        const updateSelectedIds = (setSelectedIds, setSelectedIds1) => {
            setSelectedIds(prevIds =>
                isChecked ? [...prevIds, ticketID] : prevIds.filter(id => id != ticketID)
            );
            setSelectedIds1(prevIds => {
                const nextItems = isChecked
                    ? [...prevIds, { id: ticketID, allpartstotal: allpartstotal, sub_total: sub_total, studentID: studentID || null, batchflag, repairstatus }]
                    : prevIds.filter(item => item.id !== ticketID);

                setIsModal(prev => ({ ...prev, CreateBatchbuttonVisible: hasZeroFlag(nextItems) }));
                return nextItems;
            });
        };

        switch (ticketFlag) {
            case 'open':
                updateSelectedIds(setSelectedIdsOpen, setSelectedIdsOpen1);
                break;
            case 'repairfinished':
                updateSelectedIds(setSelectedIdsRepairFinished, setSelectedIdsRepairFinished1);
                break;
            case 'repairbilled':
                updateSelectedIds(setSelectedIdsRepairBilled, setSelectedIdsRepairBilled1);
                break;
            case 'sentout':
                updateSelectedIds(setSelectedIdsSentOut, setSelectedIdsSentOut1);
                break;
            case 'atvendor':
                updateSelectedIds(setSelectedIdsAtVendor, setSelectedIdsAtVendor1);
                break;
            case 'closed':
                updateSelectedIds(setSelectedIdsClosed, setSelectedIdsClosed1);
                break;
            default:
                break;
        }
    }
    function RepairdetailsScreen(TicketID, FlagParent, RepairStatus) {
        setTicketParams({ ...TicketParams, ticketId: TicketID, });
        var tabTicketId = TicketID
        var schoolid = schoolId
        var workedonflag = 1
        var tickettabflag = tabflag
        var parentalCoverageFlag = FlagParent
        var RepairStatus = RepairStatus
        navigate('/repair-details', { state: { tabTicketId, tickettabflag, workedonflag, schoolid, parentalCoverageFlag, RepairStatus } });
    }
    const handleSortClick = (item) => {
        if (item == 'User') {
            item = 'device_user_first_name'
        } else if (item == 'parts_total') {
            item = 'sub_total'
        } else if (item == 'created_by') {
            item = 'first_name'
        } else if (item == 'Device_complete_club') {
            item = 'Parental_coverage'
        }
        if (TicketsTabs.sentOutForRepair == 'active') {
            if (tabflag == 1) {
                GetGridData(TicketsTabs.SearchForAtVendor, 1, selectedbatchid, item, true); setSortingNumForAtvendor(item)
            } else if (tabflag == 2) {
                GetGridData(TicketsTabs.searchForSentOutForRepair, 2, selectedbatchid, item, true); setSortingNumForSentOut(item)
            } else if (tabflag == 3) {
                GetGridData(TicketsTabs.SearchForOpen, 3, selectedbatchid, item, true); setSortingForOpen(item)
            }
        } else if (TicketsTabs.repairFinishedTicketTab == 'active') {
            if (tabflag == 4) {
                GetGridData(TicketsTabs.SearchForRepairFinished, 4, selectedbatchid, item, true); setSortingNumForRepairFinished(item)
            } else if (tabflag == 5) {
                GetGridData(TicketsTabs.SearchForRepairBilled, 5, selectedbatchid, item, true); setSortingNumForRepairBilled(item)
            } else if (tabflag == 6) {
                GetGridData(TicketsTabs.SearchForClosed, 6, selectedbatchid, item, true); setSortingNumForClosed(item)
            }
        }
    };
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "ticket_num": (
                <span className={`cursor-pointer ${(item.batch_flag == 1 || item.batch_flag == 0) && item.repair_status == 1
                    ? "blueText"
                    : (item.batch_flag == 1 || item.batch_flag == 2)
                        ? "redText"
                        : ""
                    }`} title="Show Ticket Details" ticketid={item.id} onClick={(e) => {
                        setIsModal({ ...IsModal, isTicketDetailspopup: true });
                        setTicketParams({ ...TicketParams, ticketId: item?.id, inventoryId: item?.inventory_id })
                    }
                    }>
                    <u>{item?.ticket_num}</u>
                </span >
            ),
            "Serial_number": (
                <span
                    className="cursor-pointer"
                    title="Show Device Details"
                    ticketid={item.id}
                    style={{ color: item.activecoveragetypecolor }}
                    onClick={(e) => {
                        setIsModal({ ...IsModal, isshowpopup: true });
                        setTicketParams({ ...TicketParams, inventoryId: item.inventory_id, ticketId: item.id });
                    }}
                >
                    <u>{`${item?.serial_number} ${item?.asset_tag ? `(${item?.asset_tag})` : ``}` || "-"}</u>
                </span>
            ),
            "User": item.student_id
                ? <u title="Show User Details" onClick={(e) => { setUserid(item.student_id); setUserModal(true) }} className='cursor-pointer'>{item?.device_user_first_name + ' ' + (item?.device_user_middle_name || '') + ' ' + (item?.device_user_last_name || '')}</u>
                : '-',
            "return_location": item?.return_location_building_name || '-',
            "created_at": formatDateToUsaMMDDYYYY(item.created_at) || "-",
            "created_by": item.first_name ? (item.first_name + ' ' + item.last_name) : "-",
            "parts_total": item.sub_total ? `$${item.sub_total}` : "$0",
            "Device_model": item?.device_model || "-",
            "asset_tag": item?.asset_tag || "-",
            "Grade": item?.grade || "-",
            "Parent_Guardian_Email": item?.parent_guardian_email || "-",
            "Parent_phone_number": item?.parent_phone_number || "-",
            "Parent_guardian_name": item?.parent_guardian_name || "-",
            "Device_complete_club": item?.parental_coverage == "1" ? "Yes" : "No",
            "Student_num": item?.student_num || "-",
            'CountofClaim': item?.claim_count ? (item?.claim_count >= 2 ? <b className='redText'>{item?.claim_count}</b> : item?.claim_count) : '0'
        };

        return contentMap[columnName] || null;
    }
    async function PrintTicketDetails() {
        if (!selectedIds || selectedIds.length === 0) return;
        var raw = JSON.stringify({ ticketIdArray: selectedIds });

        fetch(`${origin}/AutomaticTicketCreation.html`)
            .then((response) => response.text())
            .then((templateText) => {
                const template = jinja.compile(templateText);
                ApiCmnHeadersPostCall(`${adminCallNode}/tickets/selected-data`, raw, true).then((data) => {
                    const rendered = template.render({
                        data: JSON.parse(data),
                        Logo: print_ticket_logo,
                        Fevicon: print_ticket_fevicon,
                        coverageText: print_ticket_coverage,
                        siteLink: print_ticket_link,
                        schoolText: organization
                    });
                    const printWindow = window.open('', '_blank');
                    printWindow.document.write(rendered);
                    printWindow.document.close();
                    printWindow.document.head.insertAdjacentHTML('beforeend', `
                            <style>
                                @page {
                                    size: 4in 6in;
                                }
                                body{
                                    margin: 0;
                                    padding: 0;
                                }
                                @media print {
                                    body {
                                        -webkit-print-color-adjust: exact;
                                        color-adjust: exact;
                                    }
                                    @page {
                                        size: auto;
                                        margin: 10mm;
                                    }
                                }
                            </style>
                        `);
                    printWindow.onload = () => {
                        printWindow.print();
                        printWindow.onafterprint = () => {
                            printWindow.close();
                        };
                    };
                })
                    .catch((error) => {
                        log.error("Error loading data from API", error);
                    });
            })
            .catch((error) => {
                log.error("Error loading template", error);
            });
    }
    const renderTable = (gridData, selectedIds, showPagination, GridFlagg) => {
        return (
            <>
                <table className="table data-table mb-0">
                    <thead className='GridHeader'>
                        <tr>
                            <th scope="col">
                                {(gridData.length != 0 && hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_REPAIR_VAR)) && (
                                    <input className='form-check-input' type="checkbox"
                                        checked={
                                            selectAllFlag == 1 ||
                                            (
                                                gridData.length > 0 &&
                                                gridData.every(item => selectedIds.includes(item.id))
                                            )
                                        }
                                        disabled={selectAllFlag == 1}
                                        onChange={(e) => handleHeaderCheckboxChange(e, GridFlagg)} />
                                )
                                }
                            </th>
                            {columnNames?.map((item) => {
                                let columnName = item.replace(/_/g, ' ');
                                const transformedName = transformNameOfCol(columnName);
                                if (!transformedName) return null;
                                if (columnName == 'CountofClaim') { columnName = 'Claims' }
                                return (
                                    <th key={item} scope="col" className={`cursor-pointer fw-600 ${item == 'Serial_number' ? 'overflow-visible' : ''}`} title={`Sort by ${item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                        {item == 'Student_num' ? 'User ID' : CamelCaseWithSpaces(transformedName)}
                                        <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                        {gridData.length != 0 && item == 'Serial_number' && (
                                            <CustomFieldInfoIcon CustomFieldNames={CustomFieldNames} />
                                        )}
                                    </th>
                                );
                            })}
                            <th scope="col" className='fw-600' >Who Got Points</th>
                            {show_device_complete_club && excludeVar &&
                                schoolhaveclub == 1 &&
                                <th scope="col" className="fw-600 ps-3 text-center">{short_form_dcc} Expire Date</th>
                            }
                            <th scope="col" className='fw-600' >Status</th>
                            <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>
                                <div className="d-flex justify-content-center">
                                    Action
                                    <div className="EditHeaderIconDiv">
                                        <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2"
                                            title='Customize Headers' style={{ height: '25px' }}
                                            onClick={(e) => setCustomizationModal(true)}
                                        />
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {gridData.length != 0 ?
                            <>
                                {gridData.map((item, i) => {
                                    const isNoteVisible = noteVisibility[item.id];
                                    var returData =
                                        <tr key={i} className={`OddEvenClass tableBorderHide`}>
                                            <td className="py-12">
                                                {onlyVar ?
                                                    <></> :
                                                    <input className='form-check-input' type="checkbox" checked={selectedIds.includes(item.id)}
                                                        disabled={selectAllFlag == 1}
                                                        onChange={(e) => handleCheckboxChange(e, GridFlagg, item.id, item.sub_total, item.onlyadminpartsprice_total, item?.student_i_d, item?.batch_flag, item?.repair_status)} ticketnum={item.ticket_num} />}
                                            </td>
                                            {columnNames?.map(header => (<td className="py-12" key={header}>  {renderContentForColumn(header, item)}  </td>))}
                                            <td className="py-12 whitespace">
                                                {item?.technician_names ? CamelCaseWithSpaces(item?.technician_names?.replaceAll(",", ", ")) : '-'}
                                            </td>
                                            {show_device_complete_club && excludeVar &&
                                                schoolhaveclub == 1 &&
                                                <td className="py-12 text-center">
                                                    {item?.coverageendflag == 1 ?
                                                        <label style={{ color: "#e5c20de8" }}> {item.coverageendsin} Days</label>
                                                        :
                                                        <>-</>
                                                    }
                                                </td>
                                            }
                                            <td className='py-12 cursor-pointer whitespace'>
                                                {onlyVar ?
                                                    <label>{item?.status}</label>
                                                    :
                                                    <u title="Change Ticket Status"
                                                        onClick={(e) => { setStudentidForSatuschange(item.student_i_d); setIsModal({ ...IsModal, isTicketStatuspopup: true, TicketStatusId: item.ticket_status_id }); setTicketParams({ ...TicketParams, ticketId: item?.id }); }} ticketid={item.id}>{item?.status}</u>
                                                }
                                            </td>
                                            <td className={`py-12 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                <img src="/images/DownRoundArrow.svg" id={`DownArrow_${item.id}`} className={`cursor-pointer img-fluid ${isNoteVisible ? 'd-none' : ''}`}
                                                    onClick={() => handleArrowClick(item.id)} ticketid={item.id} title='Show More Details' />
                                                <img src="/images/UpRoundArrow.svg" id={`UpArrow_${item.id}`} className={`img-fluid cursor-pointer ${isNoteVisible ? '' : 'd-none'}`}
                                                    onClick={() => handleArrowClick(item.id)} ticketid={item.id} title='Hide More Details' />
                                                {excludeVar &&
                                                    <img src="/images/repairTech.svg" className="px-2 cursor-pointer" title="Add Repair Parts" onClick={(e) => { RepairdetailsScreen(item.id, item?.student_have_insurance_plan, item.repair_status) }} ticketid={item.id} />
                                                }
                                            </td>
                                        </tr>
                                    if (isNoteVisible) {
                                        returData = (
                                            <>
                                                {returData}
                                                <tr className={`col-12  px-5`}>
                                                    <td colSpan={18}>
                                                        <b className="font-13 pe-3"> Notes:</b>
                                                        <div style={{ display: "inline" }}> {item.notes || '-'} </div>
                                                    </td>
                                                </tr>
                                                <tr className={`col-12 py-1 px-5`}>
                                                    <td colSpan={18}>
                                                        <b className="font-13 pe-3">Device Issues:</b>
                                                        <div style={{ display: "inline" }}> {item.issue_names} </div>
                                                    </td>
                                                </tr>
                                                <tr className={`col-12 py-1 px-5`}>
                                                    <td colSpan={18}>
                                                        <b className="font-13 pe-3">Building :</b>
                                                        <div className='text-break' style={{ display: "inline" }}> {item.inventory_building_name || '-'} </div>
                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    }
                                    return returData;
                                })}
                            </>
                            :
                            <tr> <td colSpan={18} className="p-3 text-center"> No Record Found </td> </tr>
                        }
                    </tbody>
                </table>
                {showPagination && (
                    <Pagination activePage={currentPage} totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15} itemsCountPerPage={LimitForPagination} onChange={(e) => setCurrentPage(e)}
                        color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
                        itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
                )}
            </>
        );
    };
    function handleSearch(e) {
        resetGridEffectSkip();
        setCurrentPage(1);
        if (tabflag == 1) { //at vendor
            GetGridData(e.target.value, 1, selectedbatchid, null, false)
            setTicketsTabs({ ...TicketsTabs, SearchForAtVendor: e.target.value });
        } else if (tabflag == 2) { //send out for repair
            GetGridData(e.target.value, 2, selectedbatchid, null, false)
            setTicketsTabs({ ...TicketsTabs, searchForSentOutForRepair: e.target.value });
        } else if (tabflag == 3) { //open tickets
            GetGridData(e.target.value, 3, selectedbatchid, null, false)
            setTicketsTabs({ ...TicketsTabs, SearchForOpen: e.target.value });
        } else if (tabflag == 4) {//repair finished
            GetGridData(e.target.value, 4, selectedbatchid, null, false)
            setTicketsTabs({ ...TicketsTabs, SearchForRepairFinished: e.target.value });
        } else if (tabflag == 5) {//repair billed
            GetGridData(e.target.value, 5, selectedbatchid, null, false)
            setTicketsTabs({ ...TicketsTabs, SearchForRepairBilled: e.target.value });
        } else if (tabflag == 6) {//closed tickets
            GetGridData(e.target.value, 6, selectedbatchid, null, false)
            setTicketsTabs({ ...TicketsTabs, SearchForClosed: e.target.value });
        }
    }
    function handleTabClick(tabType) {
        resetGridEffectSkip();
        setGridDataForAtVendor([])
        setGridDataForRepairFinished([])
        setGridDataForRepairBilled([])
        setGridDataForSentOutTicket([])
        setGridDataForOpen([])
        setSelectedIdsOpen([])
        setSelectedIdsOpen1([])
        setSelectedIdsSentOut([])
        setSelectedIdsSentOut1([])
        setSelectedIdsAtVendor([])
        setSelectedIdsAtVendor1([])
        setSelectedIdsRepairBilled([])
        setSelectedIdsRepairBilled1([])
        setSelectedIdsRepairFinished([])
        setSelectedIdsRepairFinished1([])
        setSelectedIdsClosed([])
        setSelectedIdsClosed1([])
        setselectedbatchid(0);
        if (tabType == "open") {
            setSelectAllFlag(0)
            GetGridData(null, 1, selectedbatchid, null, false)
            settabflag(1)
            setTicketsTabs({ ...TicketsTabs, numberOfTicketCount: 0, openTicketTab: "", repairFinishedTicketTab: '', repairBilledTicketTab: '', sentOutForRepair: 'active', atVendorTicketTab: '', SearchForOpen: '', SearchForRepairFinished: '', SearchForRepairBilled: '', searchForSentOutForRepair: '', SearchForAtVendor: '', SearchForClosed: '' });
            setCurrentPage(1);
            setLimitForPagination(25);
            setSelectBuildingID("")
        } else if (tabType == "repaired") {
            setSelectAllFlag(0)
            GetGridData(null, 4, null, null, false)
            setTicketsTabs({ ...TicketsTabs, numberOfTicketCount: 0, openTicketTab: "", repairFinishedTicketTab: 'active', repairBilledTicketTab: '', sentOutForRepair: '', atVendorTicketTab: '', SearchForOpen: '', SearchForRepairFinished: '', SearchForRepairBilled: '', searchForSentOutForRepair: '', SearchForAtVendor: '', SearchForClosed: '' });
            settabflag(4);
            setCurrentPage(1);
            setLimitForPagination(25);
        }

    }
    const handleRadioChange = (flag, selectedbatchid = null) => {
        resetGridEffectSkip();
        if (flag == 1 || flag == 2 || flag == 3) {
            setTicketsTabs({
                ...TicketsTabs,
                openTicketTab: "",
                repairFinishedTicketTab: '',
                repairBilledTicketTab: '',
                sentOutForRepair: 'active',
                atVendorTicketTab: '',
                SearchForOpen: '',
                SearchForRepairFinished: '',
                SearchForRepairBilled: '',
                searchForSentOutForRepair: '',
                SearchForAtVendor: '',
                SearchForClosed: ''
            });
        } else if (flag == 4 || flag == 5 || flag == 6) {
            setTicketsTabs({
                ...TicketsTabs,
                openTicketTab: "",
                repairFinishedTicketTab: 'active',
                repairBilledTicketTab: '',
                sentOutForRepair: '',
                atVendorTicketTab: '',
                SearchForOpen: '',
                SearchForRepairFinished: '',
                SearchForRepairBilled: '',
                searchForSentOutForRepair: '',
                SearchForAtVendor: '',
                SearchForClosed: ''
            });
        }
        setselectedbatchid(0);
        settabflag(flag);
        setCurrentPage(1);
        setLimitForPagination(25);
        setSelectBuildingID("");
        GetGridData(null, flag, selectedbatchid, null, false);
    };
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAllFlag(isChecked ? 1 : 0);

        setIsModal({ ...IsModal, CreateBatchbuttonVisible: true });

        const getSelectableIds = (data) => { return data.map(item => item.id) };

        const getSelectableIds1 = (data) => {
            return data.map(item => ({
                id: item.id,
                sub_total: item.onlyadminpartsprice_total,
                allpartstotal: item.sub_total,
                studentID: item?.student_i_d || null,
                batchflag: item.batch_flag,
                repairstatus: item.repair_status,
            }));
        };

        // Collect and set for each tab
        if (isChecked) {
            setSelectedIdsOpen(getSelectableIds(GridDataForOpen));
            setSelectedIdsOpen1(getSelectableIds1(GridDataForOpen));

            setSelectedIdsRepairFinished(getSelectableIds(GridDataForRepairFinished));
            setSelectedIdsRepairFinished1(getSelectableIds1(GridDataForRepairFinished));

            setSelectedIdsSentOut(getSelectableIds(GridDataForSentOutTicket));
            setSelectedIdsSentOut1(getSelectableIds1(GridDataForSentOutTicket));

            setSelectedIdsAtVendor(getSelectableIds(GridDataForAtVendor));
            setSelectedIdsAtVendor1(getSelectableIds1(GridDataForAtVendor));

            setSelectedIdsRepairBilled(getSelectableIds(GridDataForRepairBilled));
            setSelectedIdsRepairBilled1(getSelectableIds1(GridDataForRepairBilled));

            setSelectedIdsClosed(getSelectableIds(GridDataForClosed));
            setSelectedIdsClosed1(getSelectableIds1(GridDataForClosed));

        } else {
            resetSelectedIds();
        }
    };

    function resetSelectedIds() {
        setSelectedIdsOpen([]);
        setSelectedIdsOpen1([]);
        setSelectedIdsRepairFinished([]);
        setSelectedIdsRepairFinished1([]);
        setSelectedIdsSentOut([]);
        setSelectedIdsSentOut1([]);
        setSelectedIdsAtVendor([]);
        setSelectedIdsAtVendor1([]);
        setSelectedIdsRepairBilled([]);
        setSelectedIdsRepairBilled1([]);
        setSelectedIdsClosed([]);
        setSelectedIdsClosed1([]);
        setselectedbatchid(0);
    }

    useEffect(() => {
        if (location?.state && location?.state?.search) {
            skipGridEffectRef.current = true;
            setSelectBuildingID("");
            AllReturnLocation();
            AllBatches();
            resetSelectedIds();
            setSelectAllFlag(0);

            const statusToSearchField = {
                1: "SearchForAtVendor",
                2: "searchForSentOutForRepair",
                3: "SearchForOpen",
                4: "SearchForRepairFinished",
                5: "SearchForRepairBilled",
                6: "SearchForClosed",
            };

            const searchField = statusToSearchField[location?.state?.status];

            if (location?.state?.status == 4 || location?.state?.status == 5 || location?.state?.status == 6) {
                setTicketsTabs((prev) => ({
                    ...prev,
                    repairFinishedTicketTab: "active",
                    sentOutForRepair: "",
                    ...(searchField ? { [searchField]: location.state.search } : {}),
                }));
            } else {
                setTicketsTabs((prev) => ({
                    ...prev,
                    sentOutForRepair: "active",
                    repairFinishedTicketTab: "",
                    ...(searchField ? { [searchField]: location.state.search } : {}),
                }));
            }

            GetGridData(location?.state?.search, location?.state?.status, null, null, null, true);
            navigate('/school-tickets', { state: null });
        }
    }, [location?.state]);

    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={tickets_grid_name} handleSearch={handleSearch}
                loading={loading} Alerts={alert} showsearch={schoolId || null} />
            <div className='row col-12 align-items-center pe-0 pt-2'>
                <div className='col-md-8 text-end'>
                    <Schoolsearchbar resetGridEffectSkip={resetGridEffectSkip} setSelectAllFlag={setSelectAllFlag} schlid={handleSetSchoolId} GetGridData={GetGridData}
                        setSelectedIdsOpen1={setSelectedIdsOpen1} setSelectedIdsRepairFinished1={setSelectedIdsRepairFinished1}
                        setSelectedIdsRepairBilled1={setSelectedIdsRepairBilled1} setSelectedIdsSentOut1={setSelectedIdsSentOut1}
                        setSelectedIdsAtVendor1={setSelectedIdsAtVendor1} setSelectedIdsClosed1={setSelectedIdsClosed1} SchoolLoginFlag={1} batchid={batchid}
                        setSelectedIdsOpen={setSelectedIdsOpen} setSelectedIdsRepairFinished={setSelectedIdsRepairFinished}
                        setSelectedIdsRepairBilled={setSelectedIdsRepairBilled} setSelectedIdsSentOut={setSelectedIdsSentOut}
                        setSelectedIdsAtVendor={setSelectedIdsAtVendor} setSelectedIdsClosed={setSelectedIdsClosed} tabflag={tabflag} settabflag={settabflag}
                        setCurrentPage={setCurrentPage} setSelectBuildingID={setSelectBuildingID} setselectedbatchid={setselectedbatchid} />
                </div>
                <div className='col-md-4 text-end d-flex justify-content-end'>
                    {storedSearchValue != undefined && (
                        <label className='font-13 pe-2 text-decoration-underline cursor-pointer'
                            onClick={(e) => setSchoolProfilePopup(true)}
                        >View Service Profile Details</label>
                    )}
                    {excludeVar &&
                        <>
                            {selectedIds.length != 0 && selectAllFlag == 0 && (
                                <label className='cursor-pointer px-1 w-0' onClick={PrintTicketDetails} title='Print Ticket Details' >
                                    <CustomSVG src='/images/print_ticket_details_i.svg' fill='var(--primary-color)' stroke='var(--primary-color)' height='24px' width='24px' />
                                </label>
                            )}
                            {storedSearchValue != undefined && (
                                <label className='cursor-pointer px-1 w-0' onClick={(e) => navigate('/create-ticket')} title='Create Ticket'><CustomSVG src='/images/create_ticket_i.svg' fill='var(--primary-color)' stroke='var(--primary-color)' height='24px' width='24px' /></label>
                            )}
                            {storedSearchValue != undefined && (
                                <label className='cursor-pointer px-1 w-0' onClick={(e) => navigate('/addupdate-device')} title='Create Device' ><CustomSVG src='/images/create_device_i.svg' fill='var(--primary-color)' stroke='var(--primary-color)' height='24px' width='24px' /></label>
                            )}
                        </>
                    }
                </div>
            </div>
            <div className="GridBox mt-2 p-3">
                <div className="greyBox p-3">
                    {storedSearchValue == undefined ?
                        <div className='text-center'>
                            <h1 className="PageHeading text-center mt-1" style={{ fontSize: "30px" }}>Please select {school} from the search box above to get going!</h1>
                            <img src="/images/setupplanicon.svg" className="img-fluid" style={{ height: '350px' }}></img>
                        </div>
                        : <>
                            <section>
                                <div className="row align-items-center">
                                    <div className="col-md-5 pe-0">
                                        <ul className="nav nav-tabs">
                                            <Tab isActive={TicketsTabs.sentOutForRepair == 'active'}
                                                label="All Open Tickets" onClick={() => handleTabClick('open')} col={'col-md-5'} />
                                            <Tab isActive={TicketsTabs.repairFinishedTicketTab == 'active'}
                                                label="Repaired Tickets" onClick={() => handleTabClick('repaired')} col={'col-md-5'} />
                                        </ul>
                                    </div>
                                    <div className='col-md-4 px-0'>
                                        {TicketsTabs.numberOfTicketCount > 0 ?
                                            selectAllFlag == 1 ?
                                                <p className='mb-0'>Total <b>{totalTicketCount}</b> tickets selected with a total of <b>${partsTotal}</b>.</p>
                                                :
                                                <p className='mb-0'>Total <b>{TicketsTabs.numberOfTicketCount}</b> tickets selected with a total of <b>${TicketsTabs.numberofSubtotal}</b>.</p>
                                            :
                                            <></>
                                        }
                                    </div>
                                    <div className='col-md-3 marginDetailsPopup'>
                                        {tabflag == 4 || tabflag == 5 || tabflag == 6 ?
                                            <div className='text-end'>
                                                <select onChange={(e) => {
                                                    resetGridEffectSkip();
                                                    setSelectBuildingID(e.target.value);
                                                    setCurrentPage(1);
                                                }} value={SelectBuildingID}  >
                                                    <option value="">Filter by Building</option>
                                                    {BuildingNames.map((item, i) => {
                                                        var returData;
                                                        returData = (
                                                            <option value={item?.return_location?.id} key={i}>{item?.return_location?.name} </option>
                                                        );
                                                        return returData;
                                                    })}
                                                </select>
                                            </div> : null
                                        }
                                        {tabflag == 2 && (
                                            <div className='col-md-12 pe-0'>
                                                <select
                                                    value={selectedbatchid}
                                                    onChange={(e) => {
                                                        setSelectedIdsSentOut([]);
                                                        setselectedbatchid(e.target.value);
                                                        GetGridData(TicketsTabs.searchForSentOutForRepair, tabflag, e.target.value, null, false);
                                                        setTicketsTabs({ ...TicketsTabs, numberOfTicketCount: 0, numberofSubtotal: 0 });
                                                        setSelectedIdsOpen1([]);
                                                        setSelectedIdsRepairFinished1([]);
                                                        setSelectedIdsRepairBilled1([]);
                                                        setSelectedIdsSentOut1([]);
                                                        setSelectedIdsClosed1([]);
                                                        setSelectedIdsClosed1([]);
                                                        setCurrentPage(1);
                                                    }}>
                                                    <option value="0">Incoming Batches</option>
                                                    <option value="0">All</option>
                                                    {Batches?.map((item, i) => {
                                                        if (item.hide == true) {
                                                            return null;
                                                        }
                                                        return <option key={i} value={item.id}>{item.batch_name}</option>
                                                    })}
                                                </select>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="row align-items-center mt-3">
                                    <div className='row'>
                                        <div className='d-flex font-12 pb-2 align-items-center justify-content-between'>
                                            <label className='redText'>* Batched Ticket</label>
                                            <label className='blueText'>* Repair Incomplete Tickets</label>
                                            {excludeVar && show_device_complete_club ?
                                                schoolhaveclub == 1 &&
                                                <label className="ps-5 highlight-part">
                                                    *{dcc_module_text} Ending Soon
                                                </label> : null
                                            }
                                        </div>
                                    </div>
                                    <div className='col-md-8 d-flex'>
                                        {TicketsTabs.sentOutForRepair == 'active' && (
                                            <>
                                                {[
                                                    { label: "At Vendor", flag: 1 },
                                                    { label: "Sent Out For Repair", flag: 2, selectedbatchid: selectedbatchid },
                                                    { label: "Open", flag: 3 },
                                                ].map((item, index) => (
                                                    <div key={index} className={`form-check ${index == 1 ? 'mx-4' : ''}`}>
                                                        <input
                                                            id={item.label}
                                                            className="form-check-input"
                                                            type="radio"
                                                            name='MasterInventory'
                                                            onChange={() => handleRadioChange(item.flag, item.selectedbatchid)}
                                                            checked={item.flag == tabflag}
                                                            defaultChecked={item.flag == 1}
                                                        />
                                                        <label htmlFor={item.label} className="form-check-label cursor-pointer">{item.label}</label>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                        {TicketsTabs.repairFinishedTicketTab == 'active' && (
                                            <>
                                                {[
                                                    { label: "Repair Finished", flag: 4 },
                                                    { label: "Repair Billed", flag: 5 },
                                                    { label: "Closed", flag: 6 }
                                                ].map((item, index) => (
                                                    <div key={index} className={`form-check ${index == 1 ? 'mx-4' : ''}`}>
                                                        <input
                                                            id={item.label}
                                                            className="form-check-input"
                                                            type="radio"
                                                            name='MasterInventory'
                                                            onChange={() => handleRadioChange(item.flag, item.selectedbatchid)}
                                                            checked={item.flag == tabflag}
                                                            defaultChecked={item.flag == 4}
                                                        />
                                                        <label htmlFor={item.label} className="form-check-label cursor-pointer">{item.label}</label>
                                                    </div>
                                                ))}
                                            </>
                                        )}

                                    </div>
                                    {excludeVar &&
                                        selectedIds.length != 0 &&
                                        <div className={`${IsModal.CreateBatchbuttonVisible ? '' : 'offset-md-2'} col-md-2 text-end marginDetailsPopup`}>
                                            <TicketStatusDropdown selectedbatchid={selectedbatchid} selectedIds={selectedIds}
                                                setSelectedIdsOpen={setSelectedIdsOpen} setSelectedIdsRepairFinished={setSelectedIdsRepairFinished} setSelectedIdsRepairBilled={setSelectedIdsRepairBilled}
                                                setSelectedIdsSentOut={setSelectedIdsSentOut} setSelectedIdsAtVendor={setSelectedIdsAtVendor} setSelectedIdsClosed={setSelectedIdsClosed}
                                                setSelectedIdsOpen1={setSelectedIdsOpen1} setSelectedIdsRepairFinished1={setSelectedIdsRepairFinished1} setSelectedIdsRepairBilled1={setSelectedIdsRepairBilled1}
                                                setSelectedIdsSentOut1={setSelectedIdsSentOut1} setSelectedIdsAtVendor1={setSelectedIdsAtVendor1} setSelectedIdsClosed1={setSelectedIdsClosed1}
                                                GetGridData={GetGridData} GridFlag={tabflag == 6 ? 6 : 5} schoolId={schoolId} tabflagforadmin={tabflag}
                                                SelectAllFlag={selectAllFlag} setSelectAllFlag={setSelectAllFlag} TicketsTabs={TicketsTabs} />
                                        </div>
                                    }
                                    {excludeVar &&
                                        IsModal.CreateBatchbuttonVisible == true && (
                                            <div className="col-md-2 text-end ps-2 marginDetailsPopup">
                                                <button className="BorderBtn p-2 col-12" id='createdBatchbutton' onClick={CreateBatchPopupShow}><img src="/images/AddInventory.svg" className="img-fluid pe-2" />Create Batch </button>
                                            </div>
                                        )}
                                </div>


                            </section>
                            <div className="row px-3">
                                <div className="greyBox px-0 pt-1">
                                    {hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_REPAIR_VAR) ?
                                        selectedIdsAtVendor.length != 0 || selectedIdsSentOut.length != 0 || selectedIdsOpen.length != 0 || selectedIdsRepairFinished.length != 0 || selectedIdsRepairBilled.length != 0 || selectedIdsClosed.length != 0 ?
                                            <div className="col-12 fw-600">
                                                <input className="form-check-input cursor-pointer mt-1 me-2" type="checkbox" name="selectall"
                                                    checked={selectAllFlag == 1} onChange={handleSelectAll} />
                                                Select All {TicketsTabs.sentOutForRepair == 'active' ? "Open" :
                                                    "Repaired"} Tickets
                                            </div>
                                            : null
                                        : <></>}
                                    <div className="data-table-container overflow-y-hidden" ref={tableWrapperRef}>
                                        {tabflag == 1 ?
                                            <>  {renderTable(GridDataForAtVendor, selectedIdsAtVendor, showPaginationAtVendor, "atvendor")}</>
                                            : tabflag == 2 ?
                                                <>{renderTable(GridDataForSentOutTicket, selectedIdsSentOut, showPaginationSendOut, "sentout")}  </>
                                                : tabflag == 3 ?
                                                    <>   {renderTable(GridDataForOpen, selectedIdsOpen, showPaginationOpen, "open")}  </>
                                                    : tabflag == 4 ?
                                                        <>{renderTable(GridDataForRepairFinished, selectedIdsRepairFinished, showPaginationRepairFinished, "repairfinished")} </>
                                                        : tabflag == 5 ?
                                                            <>{renderTable(GridDataForRepairBilled, selectedIdsRepairBilled, showPaginationRepairBilled, "repairbilled")} </>
                                                            : tabflag == 6 ?
                                                                <>{renderTable(GridDataForClosed, selectedIdsClosed, showPaginationClosed, "closed")} </>
                                                                : <></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
            {IsModal.isTicketDetailspopup && <TicketDetailsPopup isShow={IsModal.isTicketDetailspopup} ticketid={TicketParams.ticketId} inventoryid={TicketParams.inventoryId} ClosePopup={(e) => setIsModal({ ...IsModal, isTicketDetailspopup: false })} BatchNmFlag={1} />}
            {IsModal.isshowpopup &&
                <DeviceDetailsPopup
                    Showbuttons={1}
                    createticketbutton={true}
                    deviceid={TicketParams.inventoryId}
                    ticketid={TicketParams.ticketId}
                    activetab="device"
                    isShow={IsModal.isshowpopup}
                    ClosePopup={(e) => setIsModal({ ...IsModal, isshowpopup: false })}
                />
            }

            {IsModal.CreateBatchmodal &&
                <AdminCreateBatch isShow={IsModal.CreateBatchmodal} IsModal={IsModal} setIsModal={setIsModal}
                    schoolId={schoolId} selectedItems={selectedItems} setSelectedItems={setSelectedItems} setselectedbatchid={setselectedbatchid}
                    GetGridData={GetGridData} tabflag={tabflag} batchid={batchid}
                    setSelectedIdsOpen={setSelectedIdsOpen} setSelectedIdsClosed={setSelectedIdsClosed}
                    setSelectedIdsRepairFinished={setSelectedIdsRepairFinished}
                    setSelectedIdsRepairBilled={setSelectedIdsRepairBilled}
                    setSelectedIdsSentOut={setSelectedIdsSentOut} setSelectedIdsClosed1={setSelectedIdsClosed1}
                    selectAllFlag={selectAllFlag} TicketsTabs={TicketsTabs} setTicketsTabs={setTicketsTabs}
                    setSelectedIds={setSelectedIds} setSelectAllFlag={setSelectAllFlag}
                    setSelectedIdsAtVendor={setSelectedIdsAtVendor}
                    setSelectedIdsOpen1={setSelectedIdsOpen1} setSelectedIdsRepairFinished1={setSelectedIdsRepairFinished1}
                    setSelectedIdsRepairBilled1={setSelectedIdsRepairBilled1} setSelectedIdsSentOut1={setSelectedIdsSentOut1} setSelectedIdsAtVendor1={setSelectedIdsAtVendor1}
                />}

            {IsModal.isTicketStatuspopup && <TicketStatuspopup SelectAllFlag={selectAllFlag} setSelectAllFlag={setSelectAllFlag} tabflagforadmin={tabflag}
                isShow={IsModal.isTicketStatuspopup} StudentidForSatuschange={StudentidForSatuschange}
                selectedbatchid={selectedbatchid} ClosePopup={(e) => setIsModal({ ...IsModal, isTicketStatuspopup: false })}
                flag={tabflag} TicketId={TicketParams.ticketId} GridFlag={tabflag == 6 ? 6 : 5}
                GetGridData={GetGridData} schoolId={schoolId}
                TicketStatusId={IsModal.TicketStatusId} TicketsTabs={TicketsTabs}
                setSelectedIdsOpen={setSelectedIdsOpen} setSelectedIdsRepairFinished={setSelectedIdsRepairFinished} setSelectedIdsRepairBilled={setSelectedIdsRepairBilled}
                setSelectedIdsSentOut={setSelectedIdsSentOut} setSelectedIdsAtVendor={setSelectedIdsAtVendor} setSelectedIdsClosed={setSelectedIdsClosed}
                setSelectedIdsOpen1={setSelectedIdsOpen1} setSelectedIdsRepairFinished1={setSelectedIdsRepairFinished1} setSelectedIdsRepairBilled1={setSelectedIdsRepairBilled1}
                setSelectedIdsSentOut1={setSelectedIdsSentOut1} setSelectedIdsAtVendor1={setSelectedIdsAtVendor1} setSelectedIdsClosed1={setSelectedIdsClosed1}
            />}
            {CustomizationModal && <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={tickets_grid_name} GetCall={() => ApiGetHeaders(26, setColumnNames, 1, StateData?.AdminSchoolId)} />}
            {UserModal && <UserDetailsPopup isShow={UserModal} ClosePopup={(e) => setUserModal(false)} userid={Userid} />}
            {schoolProfilePopup && <Popup isshow={schoolProfilePopup} size={"lg"} title={`${organization} Profile and Pricing Details`}
                closePopup={(e) => setSchoolProfilePopup(false)} modalBody={<SchoolProfileInfo schoolId={schoolId} />} visibleSaveBtn={false} />}
        </React.Fragment>
    )
}
